$(document).ready(function() {
	if(!document.querySelector('.C0042')) return false;	

	var component_01 = function(){
		var p = component_01.prototype;

		p.init = function(){
			this.eventOn();
		};

		p.eventOn = function(){

			// accordian open event
			this.binderElem.$open.on("click", function(e){
				e.preventDefault();

				// open
				$(this).closest(".component").children(".desc").addClass("bg-gray");
				$(this).closest(".list-btn-area").next(".more-content").addClass("open").slideDown(400);
				$(this).attr('aria-expanded', true); /* PJTWAUS-1_KJB :20200207 add*/

				// find scroll line
				var tg = $(this).closest(".component"),
					adjustOption = ($(".C0011").length>0) ? Math.round($(".C0011").outerHeight()) : 0,
					contTop = tg.find(".more-content").offset().top,
					contAdjustTop = Math.round(contTop - adjustOption);

				// scrolling 
				p.scrolling(contAdjustTop);
			});

			// accordian close event
			this.binderElem.$close.on("click", function(e){
				e.preventDefault();

				// close
				$(this).closest(".component").children(".desc").removeClass("bg-gray");
				$(this).closest(".more-content").removeClass("open").slideUp(400);
				$(this).closest(".more-content").siblings(".list-btn-area").children(".more").attr('aria-expanded',false); /* PJTWAUS-1_KJB :20200207 add*/

				// find scroll line
				var tg = $(this).closest(".component"),
					adjustOption = ($(".C0011").length>0) ? Math.round($(".C0011").outerHeight()) : 0,
					tgTop = tg.offset().top,
					tgAdjustTop = Math.round(tgTop - adjustOption);

				// scrolling
				p.scrolling(tgAdjustTop);
				
			});

			// scroll event
			$(window).on("scroll", function(){
				var scrollPos = $(window).scrollTop(),
					lineCheck = 1200; // temporary

				p.gnbStickToLine( (scrollPos > lineCheck) );
			});
		};

			p.theElem = $("*[class*=\"C0042\"]"); /* PJTWAUS-1_KJB : 20200304 modify */
		
		p.binderElem = {
			$open : p.theElem.find(".list-btn-area").children(".more"),
			$close : p.theElem.find(".in-list-btn-area").children(".in-close")
		};

		p.scrolling = function(st){
			$("html, body").stop().animate({
				scrollTop : st
			},400);
		};
		
		p.gnbStickToLine = function(condition){
			if(condition){
				$(".temp-gnb").addClass("fixed");
			}else{
				$(".temp-gnb").removeClass("fixed");
			}
		};

		p.init();
	};
	component_01();
	$('.C0042').each(function(){
		var $iconblock = $(this).find('.C0088');
		if ($iconblock.length) {
			var componentCarouselSimple = {
				$el : null,
				init : function() {
					this.$el = $iconblock;
					this.$el.find('.spec-list').not('.none-slide').not('.slick-initialized').each(function(){
						if($(this).find('.item').length>1) {
							componentCarouselSimple.runSlick($(this));
							$(this).parents('.C0088').addClass('bindSlick');
						}
					});
				},
				runSlick: function($obj) {
					$obj.slick({
						appendDots:$obj.siblings('.slick-indicator').find('.slick-dot-wrap'),
						responsive: [
							{
								breakpoint: 9999,
								settings: 'unslick'
							},
							{
								breakpoint: 767,
								settings: {
									infinite: false,
									slidesToShow: 1,
									slidesToScroll: 1,
									arrows : false,
									dots: true,
								}
							}
						]
					});
					$obj.on('afterChange', function(event, slick, currentSlide){
						//console.log('..');
					});
					$obj.on('breakpoint', function(event, slick, breakpoint) {
						// console.log('breakpoint ' +  breakpoint);
						if( breakpoint === 767 ) {
							eventStopOn();
						}
						if ( breakpoint === 9999 ) {
							$obj.off('mousedown.stop touchstart.stop');
						}
					});
					$(window).on('resize',function(){
						$obj.slick('resize');
						if( ! mql.maxSm.matches) {
							$obj.find('.item').removeAttr('role id tabindex aria-describedby aria-hidden');
						}
					}).resize();
					function eventStopOn() {
						$obj.on('mousedown.stop touchstart.stop', function (e) {
							e.stopPropagation();
						});
					}
					if( mql.maxSm.matches) {
						eventStopOn();
					}
				}
			};
			componentCarouselSimple.init();
		}
	});
});


